<nav i18n-aria-label="@@hermes.accessibility.main-navigation" aria-label="Main navigation" role="navigation">
    <button (click)="goBackLink()" class="back-button">
        <h-svg-icon [name]="'back-arrow'"></h-svg-icon>
        <span class="back-arrow-txt paragraph-medium" i18n="@@node--hermes-product-display-default.back">back</span>
    </button>
</nav>
